import React from 'react'
import { Timeline, Divider } from 'antd'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faTrophy from '@fortawesome/fontawesome-free-solid/faTrophy'

const Competitions = ({

}) => {
  return (
    <div className="container">
      <h3> <FontAwesomeIcon icon={faTrophy} /> COMPETITIONS </h3>
      <Divider />
      <Timeline className="my-5">
        <Timeline.Item color="green">ACM-ICPC Thailand Southern Programming Contest 2013 | Rank: 58</Timeline.Item>
        <Timeline.Item color="green">ACM-ICPC Thailand Southern Programming Contest 2014 | Rank: 26</Timeline.Item>
        <Timeline.Item color="green">ACM-ICPC Thailand Southern Programming Contest 2015 | Rank: 11</Timeline.Item>
        <Timeline.Item color="green">ACM-ICPC Thailand Southern Programming Contest 2016 | Rank: 3</Timeline.Item>
        <Timeline.Item color="red">
          2017 Internship @Pi R Square
        </Timeline.Item>
        <Timeline.Item>
         2017-2018 Full Stack Pokemon @Pi R Square
        </Timeline.Item>
      </Timeline>
    </div>
  )
}

export default Competitions


// WEBPACK FOOTER //
// ./src/components/Competitions.js